import React from 'react';
import { useLocation } from 'react-router-dom';

export type NoCrawlersSelection = {
  noCrawlersSelected: boolean;
  setNoCrawlersSelected: (noneSelected: boolean) => void;
  noteOwnNavigation: () => void;
};

// "No crawlers" has no URL encoding: an absent crawler param already means
// every crawler.
export function useNoCrawlersSelected(): NoCrawlersSelection {
  const { key: locationKey } = useLocation();
  const [noCrawlersSelected, setNoCrawlersSelected] = React.useState(false);
  const pendingOwnNavigations = React.useRef(0);

  React.useEffect(() => {
    if (pendingOwnNavigations.current > 0) {
      pendingOwnNavigations.current -= 1;
      return;
    }
    setNoCrawlersSelected(false);
  }, [locationKey]);

  const noteOwnNavigation = React.useCallback(() => {
    pendingOwnNavigations.current += 1;
  }, []);

  return { noCrawlersSelected, setNoCrawlersSelected, noteOwnNavigation };
}
